var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"codeBtn",attrs:{"size":"small","type":"primary","disabled":_vm.showGetCode},on:{"click":function($event){return _vm.getCode()}}},[_vm._v(_vm._s(_vm.codeText))])}
var staticRenderFns = []

export { render, staticRenderFns }